import React from 'react';
import styled from 'styled-components';

export const Layerbar = ({ children }) => {
  return (
    <LayerbarContainer>
      <ContentContainer>{children}</ContentContainer>
    </LayerbarContainer>
  );
};

const LayerbarContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(60, 57, 61, 0.35);
  z-index: 999;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  * {
    box-sizing: border-box;
  }
`;

const ContentContainer = styled.div.attrs({
  'data-layerbar-scroll': true,
})`
  width: min(460px, 100vw);
  height: 100%;
  background-color: white;
  border-left: 1px solid #eaeaea;
  box-shadow:
    0px 24px 48px -8px rgba(90, 94, 107, 0.06),
    0px 2px 4px 0px rgba(90, 94, 107, 0.12);
  padding: 24px;
  overflow: auto;
`;
